/* eslint-disable no-restricted-syntax */
import TagManager from 'react-gtm-module';

const isObject = (obj) => obj === Object(obj) && !Array.isArray(obj);

const parseDataLayer = (dataLayer, args) => {
  let dataLayerParsed = { ...dataLayer };
  for (const [key, value] of Object.entries(dataLayer)) {
    for (const arg of args) {
      if (isObject(value) && arg.key in value) {
        dataLayerParsed = {
          ...dataLayerParsed,
          [key]: {
            ...dataLayerParsed[key],
            [arg.key]: value[arg.key].replace(`%${arg.param}%`, arg.value),
          },
        };
      } else if (key === arg.key) {
        dataLayerParsed = {
          ...dataLayerParsed,
          [key]: value.replace(`%${arg.param}%`, arg.value),
        };
      }
    }
  }
  return dataLayerParsed;
};

const sendAnalytics = (dataLayer, args = []) => {
  const tagManagerArgs = {};
  tagManagerArgs.dataLayer = args.length > 0 ? parseDataLayer(dataLayer, args) : dataLayer;
  TagManager.dataLayer(tagManagerArgs);
};
  
export default sendAnalytics;
